"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeatingHeartHint = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const device_1 = require("@completeanatomy/device");
const hooks_1 = require("../../hooks");
const react_transition_group_1 = require("react-transition-group");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function BeatingHeartHint() {
    const beatingHeartState = (0, hooks_1.useBeatingHeartState)();
    const [isShow, setShow] = (0, react_1.useState)(true);
    const { isMobile } = (0, device_1.usePlatform)();
    (0, react_1.useEffect)(() => {
        setShow(true);
    }, [beatingHeartState === null || beatingHeartState === void 0 ? void 0 : beatingHeartState.isPaused]);
    const hideHint = () => setShow(false);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isShow, timeout: 500, appear: true, mountOnEnter: true, unmountOnExit: true, onEntered: hideHint, "data-e2e": 'BeatingHeartHint_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { "$isMobile": isMobile, "data-e2e": 'BeatingHeartHint_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'BeatingHeartHint_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.beatingHeart.name) }), (0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'BeatingHeartHint_Subtitle', children: !(beatingHeartState === null || beatingHeartState === void 0 ? void 0 : beatingHeartState.isPaused)
                        ? (0, i18n_1.Localized)(i18n_1.Strings.common.on)
                        : (0, i18n_1.Localized)(i18n_1.Strings.common.off) })] }) }));
}
exports.BeatingHeartHint = BeatingHeartHint;
const Container = styled_components_1.default.div `
  position: absolute;
  bottom: 90px;
  left: 30px;

  ${({ $isMobile }) => $isMobile &&
    (0, styled_components_1.css) `
      bottom: 290px;
    `}

  display: flex;
  flex-direction: column;

  color: ${({ theme }) => theme.text};

  opacity: 0;

  transition: opacity 500ms ease-in-out;

  &.enter {
    opacity: 0;
  }

  &.enter-active,
  &.enter-done,
  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
  }
`;
const Title = styled_components_1.default.div `
  font-size: 32px;
  text-align: left;

  text-shadow: ${({ theme }) => theme.systemsHint.titleShadow};
`;
const Subtitle = styled_components_1.default.div `
  font-weight: bold;
  font-size: 46px;
  text-align: left;

  text-shadow: ${({ theme }) => theme.systemsHint.titleShadow};
`;
